module.exports = __webpack_public_path__ + "static/media/19-10.fc41e252.mp3";